export interface Project {
  slug: string;
  title: string;
  author: string;
  description: string;
  tags?: string[];
  url?: string; // overrides the default /projects/${slug}/ link when set
}

// Add a new entry here to add a project to the dashboard.
// For static HTML projects: slug must match the folder under public/projects/
//   e.g. slug: 'my-app' → public/projects/my-app/index.html
// For React page projects: set url to the React route instead.
export const projects: Project[] = [
  {
    slug: 'c4solver',
    title: 'C4AI: Minimax & Alpha-Beta Pruning',
    author: 'Grahame',
    description: 'An interactive Connect 4 AI. Watch the engine evaluate moves in real-time using minimax search with alpha-beta pruning.',
    tags: ['TypeScript', 'React', 'AI', 'Algorithms'],
    url: '/projects/c4solver',
  },
];
